import { Ref, ref } from "vue";
import { DialogService } from "@/service/DialogService";
import { RenrakuService } from "@/service/RenrakuService";
import { Renraku } from "@/types/KaisyaRenraku";
import { useAuthStore } from '@/store/auth'
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { DateUtil } from "@/utils/DateUtil";
import router from "@/routers";
import { RouterConst } from "@/const/Router";

export function useCreate() {

  const isCreating = ref(false);

  const createRenraku = (renrakuInfo: Renraku): void => {
    isCreating.value = true;

    dayjs.extend(timezone);
    dayjs.extend(utc);
    dayjs.tz.setDefault('Asia/Tokyo');

    // 登録用に変換
    renrakuInfo.start_datetime =
      DateUtil.formatFullDateTime(
        new Date(
          dayjs(renrakuInfo.tmp_start_datetime).format('YYYY-MM-DD')
          + ' '
          + renrakuInfo.start_time
        )
      );

    // 登録用に変換
    renrakuInfo.end_datetime =
      DateUtil.formatFullDateTime(
        new Date(
          dayjs(renrakuInfo.tmp_end_datetime).format('YYYY-MM-DD')
          + ' '
          + renrakuInfo.end_time
        )
      );

    // ログインユーザーID取得
    const authStore = useAuthStore();
    console.log(renrakuInfo.title);
    renrakuInfo.title = '発信者：' + authStore.user?.staff_name + '\r\n\r\n' + renrakuInfo.title;

    renrakuInfo.control_type = 'renraku';
    renrakuInfo.control_text = '確認する';

    const srv = new RenrakuService();
    DialogService.nowloading('登録中...');

    srv.createRenraku(renrakuInfo).then(res => {
      if (res) {
        DialogService.info({
          text: `会社連絡を登録しました`
        }, true);
        router.push({ name: RouterConst.RENRAKU_MENU })
      } else {
        DialogService.error({
          text: '予期せぬ事態が発生し登録に失敗しました'
        }, true);
      }
      isCreating.value = false;
    });
  }

  return {
    isCreating,
    createRenraku,
  }
}
